const environmentLocal = {
  environment: process.env.REACT_APP_ENVIRONMENT,
  isAmbienteManutencao: process.env.REACT_APP_IS_ARRECADACAO_AMBIENTE_MANUTENCAO,
  periodoEstimado: process.env.REACT_APP_ARRECADACAO_PERIODO_ESTIMADO_MANUTENCAO,
};

export const environment = {
  environment: environmentLocal.environment || 'pro',
};

export const manutencaoArrecadacao = {
  isAmbienteManutencao: environmentLocal.isAmbienteManutencao ?? 'false',
  periodoEstimado: environmentLocal.periodoEstimado ?? '01/07/2026 a 07/07/2026',
};
